export const AI_AGENTS = [
    { name: 'Charles', description: 'Accounting AI Agent', img: '/assets/agents/charles-agent.svg' },
]